import React, { useState, useEffect } from 'react';
import NavigationBar from '../../components/ui/NavigationBar';
import UserStatusIndicator from '../../components/ui/UserStatusIndicator';
import CallStatusWidget from '../../components/ui/CallStatusWidget';
import CallHistoryFilters from './components/CallHistoryFilters';
import CallHistoryTable from './components/CallHistoryTable';
import CallSummaryPanel from './components/CallSummaryPanel';
import CallRecordingPlayer from './components/CallRecordingPlayer';
import CallNotesEditor from './components/CallNotesEditor';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const CallHistoryPage = () => {
  const [filteredCalls, setFilteredCalls] = useState([]);
  const [allCalls, setAllCalls] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [selectedRecording, setSelectedRecording] = useState(null);
  const [selectedCallForNotes, setSelectedCallForNotes] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(25);

  // Mock call history data
  const mockCallData = [
    {
      id: 1,
      callId: "CALL-2024-001234",
      date: "07.11.2024",
      time: "14:30",
      dateTime: new Date("2024-11-07T14:30:00"),
      customerName: "Ahmet Yılmaz",
      company: "ABC Teknoloji Ltd.",
      phoneNumber: "+90 532 123 4567",
      type: "Gelen",
      duration: 420,
      disposition: "Başarılı",
      agentName: "Ayşe Demir",
      hasRecording: true,
      waitTime: 15,
      transferCount: 0,
      notes: `Müşteri yeni ürün hakkında detaylı bilgi talep etti. Teknik özellikler ve fiyat bilgisi verildi.\nTakip toplantısı için randevu alındı. Müşteri çok memnun kaldı.`,
      tags: ["Satış", "Teknik Destek"],
      priority: "Yüksek",
      customerHistory: [
        { date: "05.11.2024", summary: "Ürün demo talebi" },
        { date: "01.11.2024", summary: "İlk iletişim - bilgi talebi" }
      ]
    },
    {
      id: 2,
      callId: "CALL-2024-001235",
      date: "07.11.2024",
      time: "13:45",
      dateTime: new Date("2024-11-07T13:45:00"),
      customerName: "Fatma Özkan",
      company: "XYZ İnşaat A.Ş.",
      phoneNumber: "+90 533 987 6543",
      type: "Giden",
      duration: 180,
      disposition: "Meşgul",
      agentName: "Mehmet Kaya",
      hasRecording: false,
      waitTime: 0,
      transferCount: 0,
      notes: "Müşteriye ulaşılamadı, meşgul sinyali alındı. Daha sonra tekrar aranacak.",
      tags: ["Geri Arama Gerekli"],
      priority: "Orta",
      customerHistory: []
    },
    {
      id: 3,
      callId: "CALL-2024-001236",
      date: "07.11.2024",
      time: "12:15",
      dateTime: new Date("2024-11-07T12:15:00"),
      customerName: "Ali Şahin",
      company: "",
      phoneNumber: "+90 534 555 1234",
      type: "Gelen",
      duration: 600,
      disposition: "Başarılı",
      agentName: "Fatma Şahin",
      hasRecording: true,
      waitTime: 8,
      transferCount: 1,
      notes: `Müşteri mevcut hizmet ile ilgili şikayet bildirdi. Teknik ekibe yönlendirildi.\nSorun çözüldü ve müşteri memnuniyeti sağlandı. Özür dilendi ve ek hizmet teklif edildi.`,
      tags: ["Şikayet", "Teknik Destek"],
      priority: "Yüksek",
      customerHistory: [
        { date: "03.11.2024", summary: "Hizmet aktivasyonu" },
        { date: "28.10.2024", summary: "İlk kayıt" }
      ]
    },
    {
      id: 4,
      callId: "CALL-2024-001237",
      date: "07.11.2024",
      time: "11:30",
      dateTime: new Date("2024-11-07T11:30:00"),
      customerName: "Zeynep Kara",
      company: "DEF Danışmanlık",
      phoneNumber: "+90 535 777 8888",
      type: "Giden",
      duration: 300,
      disposition: "Cevapsız",
      agentName: "Ali Özkan",
      hasRecording: false,
      waitTime: 0,
      transferCount: 0,
      notes: "Müşteri telefonu açmadı. Sesli mesaj bırakıldı. Geri arama bekleniyor.",
      tags: ["Geri Arama Gerekli", "Bilgi Talebi"],
      priority: "Düşük",
      customerHistory: [
        { date: "06.11.2024", summary: "E-posta ile iletişim" }
      ]
    },
    {
      id: 5,
      callId: "CALL-2024-001238",
      date: "06.11.2024",
      time: "16:45",
      dateTime: new Date("2024-11-06T16:45:00"),
      customerName: "Hasan Demir",
      company: "GHI Lojistik",
      phoneNumber: "+90 536 999 0000",
      type: "Gelen",
      duration: 480,
      disposition: "Geri Arama",
      agentName: "Ayşe Demir",
      hasRecording: true,
      waitTime: 12,
      transferCount: 0,
      notes: `Müşteri detaylı fiyat teklifi talep etti. Özel indirim olanakları sorgulandı.\nYarın saat 10:00'da geri arama randevusu alındı.`,
      tags: ["Satış", "Geri Arama Gerekli"],
      priority: "Yüksek",
      customerHistory: [
        { date: "04.11.2024", summary: "Web sitesi üzerinden form doldurdu" }
      ]
    },
    {
      id: 6,
      callId: "CALL-2024-001239",
      date: "06.11.2024",
      time: "15:20",
      dateTime: new Date("2024-11-06T15:20:00"),
      customerName: "Elif Yıldız",
      company: "",
      phoneNumber: "+90 537 111 2222",
      type: "Gelen",
      duration: 240,
      disposition: "Yanlış Numara",
      agentName: "Mehmet Kaya",
      hasRecording: false,
      waitTime: 5,
      transferCount: 0,
      notes: "Arayan kişi yanlış numarayı aradığını belirtti. Doğru numaraya yönlendirildi.",
      tags: ["Yanlış Numara"],
      priority: "Düşük",
      customerHistory: []
    },
    {
      id: 7,
      callId: "CALL-2024-001240",
      date: "06.11.2024",
      time: "14:10",
      dateTime: new Date("2024-11-06T14:10:00"),
      customerName: "Osman Çelik",
      company: "JKL Otomotiv",
      phoneNumber: "+90 538 333 4444",
      type: "Giden",
      duration: 360,
      disposition: "Başarılı",
      agentName: "Fatma Şahin",
      hasRecording: true,
      waitTime: 0,
      transferCount: 0,
      notes: `Müşteri ile aylık hizmet toplantısı yapıldı. Mevcut durumdan memnun olduğunu belirtti.\nYeni hizmet paketleri hakkında bilgi verildi. Değerlendirme süreci başlatıldı.`,
      tags: ["Satış", "Yenileme"],
      priority: "Orta",
      customerHistory: [
        { date: "06.10.2024", summary: "Aylık değerlendirme toplantısı" },
        { date: "06.09.2024", summary: "Hizmet başlangıcı" }
      ]
    },
    {
      id: 8,
      callId: "CALL-2024-001241",
      date: "06.11.2024",
      time: "13:00",
      dateTime: new Date("2024-11-06T13:00:00"),
      customerName: "Selin Aydın",
      company: "MNO Eğitim",
      phoneNumber: "+90 539 555 6666",
      type: "Gelen",
      duration: 720,
      disposition: "Başarılı",
      agentName: "Ali Özkan",
      hasRecording: true,
      waitTime: 20,
      transferCount: 2,
      notes: `Müşteri kapsamlı eğitim paketi hakkında detaylı bilgi aldı. Fiyat ve içerik karşılaştırması yapıldı.\nÖzel indirim uygulandı ve sözleşme imzalandı. Başlangıç tarihi belirlendi.`,
      tags: ["Satış", "Eğitim"],
      priority: "Yüksek",
      customerHistory: [
        { date: "02.11.2024", summary: "Web sitesi ziyareti" },
        { date: "30.10.2024", summary: "Broşür talebi" }
      ]
    }
  ];

  // Mock recording data
  const mockRecordings = {
    1: {
      callId: "CALL-2024-001234",
      customerName: "Ahmet Yılmaz",
      date: "07.11.2024",
      time: "14:30",
      duration: "7:00",
      agentName: "Ayşe Demir",
      quality: "HD",
      audioUrl: "https://www.soundjay.com/misc/sounds/bell-ringing-05.wav",
      notes: "Kaliteli ses kaydı. Müşteri memnuniyeti yüksek."
    },
    3: {
      callId: "CALL-2024-001236",
      customerName: "Ali Şahin",
      date: "07.11.2024",
      time: "12:15",
      duration: "10:00",
      agentName: "Fatma Şahin",
      quality: "HD",
      audioUrl: "https://www.soundjay.com/misc/sounds/bell-ringing-05.wav",
      notes: "Şikayet çözüm süreci kaydedildi."
    }
  };

  // Calculate summary data
  const calculateSummaryData = (calls) => {
    const totalCalls = calls?.length;
    const totalDuration = calls?.reduce((sum, call) => sum + call?.duration, 0);
    const averageDuration = totalCalls > 0 ? Math.round(totalDuration / totalCalls) : 0;
    
    const successfulCalls = calls?.filter(call => call?.disposition === 'Başarılı')?.length;
    const successRate = totalCalls > 0 ? (successfulCalls / totalCalls) * 100 : 0;
    
    const inboundCalls = calls?.filter(call => call?.type === 'Gelen')?.length;
    const outboundCalls = calls?.filter(call => call?.type === 'Giden')?.length;
    const recordedCalls = calls?.filter(call => call?.hasRecording)?.length;

    const dispositionBreakdown = {
      successful: calls?.filter(call => call?.disposition === 'Başarılı')?.length,
      busy: calls?.filter(call => call?.disposition === 'Meşgul')?.length,
      noAnswer: calls?.filter(call => call?.disposition === 'Cevapsız')?.length,
      callback: calls?.filter(call => call?.disposition === 'Geri Arama')?.length,
      wrongNumber: calls?.filter(call => call?.disposition === 'Yanlış Numara')?.length
    };

    const peakHours = [
      { time: '09:00-10:00', calls: 45 },
      { time: '14:00-15:00', calls: 52 },
      { time: '10:00-11:00', calls: 38 },
      { time: '15:00-16:00', calls: 41 }
    ];

    return {
      totalCalls,
      totalDuration,
      averageDuration,
      successRate,
      inboundCalls,
      outboundCalls,
      recordedCalls,
      dispositionBreakdown,
      peakHours
    };
  };

  useEffect(() => {
    // Simulate loading
    setIsLoading(true);
    setTimeout(() => {
      setAllCalls(mockCallData);
      setFilteredCalls(mockCallData);
      setSummaryData(calculateSummaryData(mockCallData));
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleFilterChange = (filters) => {
    let filtered = [...allCalls];

    // Apply search filter
    if (filters?.searchTerm) {
      const searchLower = filters?.searchTerm?.toLowerCase();
      filtered = filtered?.filter(call =>
        call?.customerName?.toLowerCase()?.includes(searchLower) ||
        call?.phoneNumber?.includes(searchLower) ||
        call?.notes?.toLowerCase()?.includes(searchLower) ||
        call?.callId?.toLowerCase()?.includes(searchLower)
      );
    }

    // Apply date filters
    if (filters?.dateFrom) {
      const fromDate = new Date(filters.dateFrom);
      filtered = filtered?.filter(call => call?.dateTime >= fromDate);
    }

    if (filters?.dateTo) {
      const toDate = new Date(filters.dateTo);
      toDate?.setHours(23, 59, 59, 999);
      filtered = filtered?.filter(call => call?.dateTime <= toDate);
    }

    // Apply other filters
    if (filters?.callType) {
      filtered = filtered?.filter(call => call?.type === filters?.callType);
    }

    if (filters?.disposition) {
      filtered = filtered?.filter(call => call?.disposition === filters?.disposition);
    }

    if (filters?.agent) {
      filtered = filtered?.filter(call => call?.agentName === filters?.agent);
    }

    setFilteredCalls(filtered);
    setSummaryData(calculateSummaryData(filtered));
    setCurrentPage(1);
  };

  const handleResetFilters = () => {
    setFilteredCalls(allCalls);
    setSummaryData(calculateSummaryData(allCalls));
    setCurrentPage(1);
  };

  const handleExport = () => {
    // Simulate export functionality
    const csvContent = [
      ['Tarih', 'Saat', 'Müşteri', 'Telefon', 'Tür', 'Süre', 'Sonuç', 'Temsilci', 'Notlar']?.join(','),
      ...filteredCalls?.map(call => [
        call?.date,
        call?.time,
        call?.customerName,
        call?.phoneNumber,
        call?.type,
        `${Math.floor(call?.duration / 60)}:${(call?.duration % 60)?.toString()?.padStart(2, '0')}`,
        call?.disposition,
        call?.agentName,
        `"${call?.notes?.replace(/"/g, '""')}"`
      ]?.join(','))
    ]?.join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link?.setAttribute('href', url);
    link?.setAttribute('download', `arama-gecmisi-${new Date()?.toISOString()?.split('T')?.[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
  };

  const handlePlayRecording = (callId) => {
    const recording = mockRecordings?.[callId];
    if (recording) {
      setSelectedRecording(recording);
    }
  };

  const handleEditNotes = (callId) => {
    const call = allCalls?.find(c => c?.id === callId);
    if (call) {
      setSelectedCallForNotes(call);
    }
  };

  const handleSaveNotes = (updatedCall) => {
    const updatedCalls = allCalls?.map(call =>
      call?.id === updatedCall?.id ? updatedCall : call
    );
    setAllCalls(updatedCalls);
    
    const updatedFiltered = filteredCalls?.map(call =>
      call?.id === updatedCall?.id ? updatedCall : call
    );
    setFilteredCalls(updatedFiltered);
    setSelectedCallForNotes(null);
  };

  // Pagination
  const totalPages = Math.ceil(filteredCalls?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentCalls = filteredCalls?.slice(startIndex, endIndex);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50">
        <NavigationBar />
        <UserStatusIndicator />
        <CallStatusWidget />
        
        <div className="content-offset px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <Icon name="Loader2" size={32} className="animate-spin text-primary mx-auto mb-4" />
              <p className="text-slate-600">Arama geçmişi yükleniyor...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <NavigationBar />
      <UserStatusIndicator />
      <CallStatusWidget />
      <div className="content-offset px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-slate-900">Arama Geçmişi</h1>
              <p className="text-slate-600 mt-2">
                Detaylı arama kayıtlarını inceleyin ve performans analizleri yapın
              </p>
            </div>
            <div className="flex items-center space-x-3">
              <div className="text-sm text-slate-600">
                Toplam {filteredCalls?.length} kayıt
              </div>
              <Button
                variant="outline"
                onClick={handleExport}
                iconName="Download"
                iconPosition="left"
              >
                Dışa Aktar
              </Button>
            </div>
          </div>
        </div>

        {/* Summary Panel */}
        <div className="mb-8">
          <CallSummaryPanel summaryData={summaryData} />
        </div>

        {/* Filters */}
        <CallHistoryFilters
          onFilterChange={handleFilterChange}
          onExport={handleExport}
          onReset={handleResetFilters}
        />

        {/* Call History Table */}
        <div className="mb-6">
          <CallHistoryTable
            calls={currentCalls}
            onPlayRecording={handlePlayRecording}
            onEditNotes={handleEditNotes}
            onViewDetails={(callId) => console.log('View details:', callId)}
          />
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-between bg-white px-6 py-3 border border-slate-200 rounded-lg">
            <div className="flex items-center text-sm text-slate-600">
              <span>
                {startIndex + 1}-{Math.min(endIndex, filteredCalls?.length)} arası, 
                toplam {filteredCalls?.length} kayıt
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
                iconName="ChevronLeft"
              />
              
              <div className="flex items-center space-x-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }
                  
                  return (
                    <Button
                      key={pageNum}
                      variant={currentPage === pageNum ? "default" : "ghost"}
                      size="sm"
                      onClick={() => setCurrentPage(pageNum)}
                      className="w-8 h-8 p-0"
                    >
                      {pageNum}
                    </Button>
                  );
                })}
              </div>
              
              <Button
                variant="outline"
                size="sm"
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
                iconName="ChevronRight"
              />
            </div>
          </div>
        )}
      </div>
      {/* Modals */}
      {selectedRecording && (
        <CallRecordingPlayer
          recording={selectedRecording}
          onClose={() => setSelectedRecording(null)}
        />
      )}
      {selectedCallForNotes && (
        <CallNotesEditor
          call={selectedCallForNotes}
          onSave={handleSaveNotes}
          onClose={() => setSelectedCallForNotes(null)}
        />
      )}
    </div>
  );
};

export default CallHistoryPage;